export default __webpack_public_path__ + "static/media/view-eye-gray.0180ad40.svg";